<section ubl-text class="content" *ngIf="data" [ublText]="data.description.value">
  <app-button *ngIf="data.link.value" class="content__link" [withArrow]="true" [data]="data.link.value"></app-button>
</section>